import { endpoints } from "@app/api/apis";
import { getApplicationId } from "@app/screens/FetchPortfolio/utils";
import { BUILD_TYPE, getBuildType, ROUTE } from "@voltmoney/micro-frontend";
import axios from "axios";

export const generateShareLinkV2Utils = async({
    userDetails,
    // setDatastore,
    // network
  }: {
    userDetails: any
    // setDatastore: StandardUtilities['setDatastore'],
    // network: StandardUtilities['network']
  }) => {
    const user = userDetails;
    const application_id = await getApplicationId(user?.linkedApplications[0]?.applicationId);
    const platform = user?.linkedPlatformAccounts[0]?.platformCode || null;
    let appDomain = '';
    const buildType = getBuildType();
    switch(buildType) {
        case BUILD_TYPE.BORROWER_PRODUCTION:
            appDomain = 'app.voltmoney.in'
            break;
        case BUILD_TYPE.BORROWER_STAGING:
            appDomain = 'app.staging.voltmoney.in'
            break;
        case BUILD_TYPE.BORROWER_QA_STAGING:
            appDomain = 'qa.staging.voltmoney.in'
            break;
        case BUILD_TYPE.BORROWER_TEST_STAGING:
            appDomain = 'test.staging.voltmoney.in'
            break;
        case BUILD_TYPE.BORROWER_LMS_STAGING:
            appDomain = 'lms.staging.voltmoney.in'
            break;
        case BUILD_TYPE.BORROWER_LOS_STAGING:
            appDomain = 'los.staging.voltmoney.in'
            break;
        default:
            appDomain = 'app.staging.voltmoney.in'        
    }
  
    //HANDLE FOR PLATFORMS
    const platformExcludeList = ['VOLT_MOBILE_APP', 'VOLT_WEB_APP', 'VOLT_API_UAT', 'VOLT_API_INTEGRATION'];
    if(platform && !platformExcludeList.includes(platform)) {
        appDomain = appDomain + `/partnerplatform?platform=${platform}`;
    }
  
    const response = await axios.post(`${endpoints.generateMfdShareLink}`, {
        applicationId: application_id,
        stepId: ROUTE.KYC_PHOTO_VERIFICATION,
        appDomain: appDomain
    })
    if(response?.status === 200) {
        return response?.data?.shortUrl;
    } else {
        return null;
    }
  }